/**
 * Shared framer-motion animation constants.
 *
 * Defining these at module scope (instead of inline props) prevents React
 * from allocating a fresh object on every render, which is what makes
 * framer-motion's internal memoization actually kick in.
 *
 * Naming convention:
 *   FADE_*   — opacity transitions
 *   SLIDE_*  — translate transitions
 *   POP_*    — scale transitions
 *   SPIN_*   — rotate transitions
 *   <X>_IN / <X>_OUT  — paired initial/animate or animate/exit objects
 *
 * When you need a one-off variant, compose: `{ ...FADE_IN_UP, delay: 0.2 }`.
 */

// --- Pure fades ---------------------------------------------------------
export const FADE_IN = { opacity: 0 };
export const FADE_ANIMATE = { opacity: 1 };
export const FADE_OUT = { opacity: 0 };

// --- Fade + translate Y -------------------------------------------------
export const FADE_UP_20 = { opacity: 0, y: 20 };
export const FADE_UP_10 = { opacity: 0, y: 10 };
export const FADE_Y_ANIMATE = { opacity: 1, y: 0 };
export const FADE_DOWN_20 = { opacity: 0, y: -20 };

// --- Fade + translate X -------------------------------------------------
export const FADE_LEFT_20 = { opacity: 0, x: -20 };
export const FADE_RIGHT_20 = { opacity: 0, x: 20 };
export const FADE_X_ANIMATE = { opacity: 1, x: 0 };
export const FADE_LEFT_EXIT = { opacity: 0, x: -20 };

// --- Scale / Pop --------------------------------------------------------
export const SCALE_IN_95 = { opacity: 0, scale: 0.95 };
export const SCALE_IN_98 = { opacity: 0, scale: 0.98 };
export const SCALE_IN_90 = { scale: 0.9, opacity: 0 };
export const SCALE_IN_80 = { scale: 0.8, opacity: 0 };
export const SCALE_ANIMATE = { opacity: 1, scale: 1 };
export const SCALE_ANIMATE_ALT = { scale: 1, opacity: 1 };
export const SCALE_ONLY_ANIMATE = { scale: 1 };

// --- Accordion / collapsing --------------------------------------------
export const ACCORDION_COLLAPSED = { opacity: 0, height: 0 };
export const ACCORDION_EXPANDED = { opacity: 1, height: 'auto' };

// --- Infinite rotation --------------------------------------------------
export const SPIN_360 = { rotate: 360 };

// --- Transitions --------------------------------------------------------
export const SPIN_TRANSITION = { duration: 20, repeat: Infinity, ease: 'linear' };
